<template>
    <div class="d-flex flex-column align-items-center">
        <span class="text-center text-secondary font-xs">You need the Home Credit app to proceed. Get the latest version on Google Play or scan the QR code below.</span>
        <img alt="" :id="googlePlayId" src="/img/hcpay/google-play.png" class="googlePlayBtn img-responsive clickable mb-2 mt-3" @click="googlePlay">
        <img alt="" :id="qrCodeId" src="/img/hcpay/hc-qrcode.png" class="QRCodeBtn img-responsive">
    </div>
</template>
<script>
export default {
    props: ['googlePlayId','qrCodeId'],
    methods: {
        googlePlay() {
            let g4Params = {
                'userId': this.$root.$data.account.userId,
                'cuid': this.$root.$data.account.cuid,
                'ip': this.$root.transaction.ipAddress,
                'user_agent': this.$root.$data.analyticsData.userAgent,
                'phone': this.$root.$data.analyticsData.phone,
                'operating_system': this.$root.$data.analyticsData.operatingSystem.name+"V"+this.$root.$data.analyticsData.operatingSystem.version,
                'browser': this.$root.$data.analyticsData.browser.name+"V"+this.$root.$data.analyticsData.browser.version,
                'transaction_type': this.$root.$data.transaction.referenceNumber.substring(0, 2),
                'transaction_reference': this.$root.$data.transaction.referenceNumber,
            }       
            this.$root.triggerG4Event('landing_install_hc_app',g4Params)
            window.location.href = 'https://bit.ly/2Y3RllU';
        }
    }
}
</script>
<style scoped>
    .googlePlayBtn {
        height: auto;
        width: 11.625rem;
    }
    .QRCodeBtn {
        height: auto;
        width: 7rem;
    }
</style>